const API_BASE_URL = "https://oneclick.atslabs.dev/api";
async function login(email, password, redirectUrl = null) {
  const res = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify(
        redirectUrl ? { email, password, redirectUrl } : { email, password }
      ),
    }),
    data = await res.json();
  if (!res.ok) throw new Error(data?.error?.message);
  console.log(data);
  return (
    localStorage.setItem("jwtToken", data.authToken),
    (window.location.href = data.multipassUrl),
    data
  );
}
async function requestOtp(phoneNumber, requestType) {
  const res = await fetch(`${API_BASE_URL}/auth/request-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify({ phoneNumber, requestType }),
    }),
    data = await res.json();
  if (!res.ok)
    throw new Error(data?.error?.message || data?.message || "API Error");
  return data.token;
}
async function verifyOtp(phoneNumber, requestType, otp, token) {
  const res = await fetch(`${API_BASE_URL}/auth/verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify({ phoneNumber, requestType, otp, token }),
    }),
    data = await res.json();
  if (!res.ok)
    throw new Error(data?.error?.message || data?.message || "API Error");
  return !0;
}
async function resetPassword(phoneNumber, otp, token, newPassword) {
  const res = await fetch(`${API_BASE_URL}/auth/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify({ phoneNumber, newPassword, otp, token }),
    }),
    data = await res.json();
  if (!res.ok)
    throw new Error(data?.error?.message || data?.message || "API Error");
  return !0;
}
async function register(
  nationalId,
  phoneNumber,
  otp,
  token,
  name,
  email,
  password,
  referralCode,
  redirectUrl = null
) {
  let input = {
    nationalId,
    phoneNumber,
    otp,
    token,
    name,
    email,
    password,
    referralCode,
  };
  referralCode != "" && (input.referralCode = referralCode),
    redirectUrl && (input.redirectUrl = redirectUrl);
  const res = await fetch(`${API_BASE_URL}/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify(input),
    }),
    data = await res.json();
  if (!res.ok)
    if (Array.isArray(data?.error)) {
      let messages = "<li>";
      throw (
        ((messages += data?.error
          .map((e) => `${e?.path.length > 0 ? e.path[0] : ""} ${e.message}`)
          .join("</li><li>")),
        (messages += "</li>"),
        new Error(messages))
      );
    } else
      throw data?.error?.message
        ? new Error(data?.error?.message)
        : new Error("Something went wrong");
  return !0;
}
async function checkUserExist(phoneNumber, nationalId) {
  const res = await fetch(`${API_BASE_URL}/users/exists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-store-id": document.querySelector('meta[name="shop"]')
          ? document.querySelector('meta[name="shop"]').content
          : null,
      },
      body: JSON.stringify({ phoneNumber, nationalId }),
    }),
    data = await res.json();
  if (!res.ok)
    throw new Error(data?.error?.message || data?.message || "API Error");
  return data;
}
function getCheckoutRedirectUrl() {
  const encodedCheckoutUrl = new URLSearchParams(window.location.search).get(
    "checkout_url"
  );
  if (!encodedCheckoutUrl) return null;
  try {
    return decodeURIComponent(decodeURIComponent(encodedCheckoutUrl));
  } catch {
    return decodeURIComponent(encodedCheckoutUrl);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".togglePassword").forEach((icon) => {
    icon.addEventListener("click", function () {
      const input = this.closest(".password-wrapper").querySelector("input"),
        isHidden = input.type === "password";
      (input.type = isHidden ? "text" : "password"),
        (this.src = isHidden ? this.dataset.eye : this.dataset.eyeSlash);
    });
  });
  let countdown = 60;
  const countdownEle = document.getElementById("countdown-request-otp-wrapper");
  countdownEle.addEventListener("click", async (e) => {
    if (e.target && e.target.id === "resent-otp") {
      const phone = e.target.dataset.phone,
        type = e.target.dataset.type;
      await requestOtp(phone, type), startCountdown(phone, type);
    }
  });
  function startCountdown(phoneNumber, type) {
    countdownEle.innerHTML = `Resend OTP in ${countdown}s`;
    const timer = setInterval(() => {
      countdown--,
        countdown > 0
          ? (countdownEle.innerHTML = `Resend OTP in ${countdown}s`)
          : (clearInterval(timer),
            (countdownEle.innerHTML = `<span id='resent-otp' data-phone='${phoneNumber}' data-type='${type}'>Resend OTP</span>`),
            (countdown = 60));
    }, 1e3);
  }
  const phoneInput = document.querySelector("#CustomerPhoneNumber"),
    errorDiv = document.querySelector("#PhoneError");
  let iti = null;
  phoneInput &&
    ((iti = intlTelInput(phoneInput, {
      initialCountry: "my",
      separateDialCode: !0,
      nationalMode: !1,
      loadUtils: () =>
        import(
          "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"
        ),
    })),
    phoneInput.addEventListener("input", validatePhone),
    phoneInput.addEventListener("countrychange", validatePhone));
  function validatePhone() {
    errorDiv.textContent = "";
    errorDiv.style.display = "none";
    phoneInput.classList.remove("error-border");

    if (!phoneInput.value.trim()) {
      errorDiv.textContent = "Phone number is required.";
      errorDiv.style.display = "block";
      phoneInput.classList.add("error-border");
      return false;
    }

    if (!iti.isValidNumber()) {
      const errorMap = [
        "Invalid number",
        "Invalid country code",
        "Too short",
        "Too long",
        "Invalid number",
      ];
      const errorCode = iti.getValidationError();
      const errorMessage = errorMap[errorCode] || "Invalid number";
      errorDiv.textContent = errorMessage;
      errorDiv.style.display = "block";
      phoneInput.classList.add("error-border");
      return false;
    }

    // Phone number is valid
    return true;
  }

  const loginForm = document.getElementById("middleware-login-form"),
    loginAlert = document.getElementById("login_alert");
  if (loginForm) {
    loginAlert.innerHTML = "";
    const submitBtn = loginForm.querySelector('button[type="submit"]');
    loginForm.addEventListener("submit", async (e) => {
      e.preventDefault(),
        (submitBtn.disabled = !0),
        (submitBtn.textContent = "Submitting...");
      const email = document.getElementById("CustomerEmail").value,
        password = document.getElementById("CustomerPassword").value;
      try {
        const redirectUrl = getCheckoutRedirectUrl();
        redirectUrl
          ? await login(email, password, redirectUrl)
          : await login(email, password);
      } catch (err) {
        (submitBtn.disabled = !1),
          (submitBtn.textContent = "Submit"),
          (loginAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>${err.message}</li></ul></div>
                  </div>`);
      }
    });
  }
  const resetForm = document.getElementById("middleware-reset-form"),
    resetAlert = document.getElementById("reset_alert");
  if (resetForm) {
    resetAlert.innerHTML = "";
    const submitBtn = resetForm.querySelector('button[type="submit"]');
    resetForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const phoneNumber = iti.getNumber().replace("+", ""),
        requestType = document.getElementById("RequestType").value,
        otpInput = document.getElementById("otpInput").value,
        otpToken = document.getElementById("otpToken").value,
        passwordInput = document.getElementById("passwordInput").value,
        confirmPasswordInput = document.getElementById(
          "confirmPasswordInput"
        ).value;
      try {
        if (otpInput == "") {
          const token = await requestOtp(phoneNumber, requestType);
          (document.getElementById(
            "reset-message"
          ).innerHTML = `One-Time Password (OTP) is sent to ${phoneNumber.slice(
            0,
            2
          )}xxxxx${phoneNumber.slice(-4)} via SMS`),
            (document.getElementById("phoneWrapper").style.display = "none"),
            (document.getElementById("otpInputWrapper").style.display =
              "block"),
            (document.getElementById(
              "countdown-request-otp-wrapper"
            ).style.display = "block"),
            (document.getElementById("otpInput").required = !0),
            (document.getElementById("otpToken").value = token),
            (submitBtn.disabled = !1),
            (submitBtn.textContent = "Submit"),
            startCountdown(phoneNumber, requestType);
        } else if (passwordInput == "") {
          const isSuccess = await verifyOtp(
            phoneNumber,
            requestType,
            otpInput,
            otpToken
          );
          (document.getElementById("reset-message").innerHTML =
            "Enter your new password to reset"),
            (document.getElementById("otpInputWrapper").style.display = "none"),
            (document.getElementById("passwordInputWrapper").style.display =
              "block"),
            (document.getElementById(
              "confirmPasswordInputWrapper"
            ).style.display = "block"),
            (document.getElementById(
              "countdown-request-otp-wrapper"
            ).style.display = "none"),
            (document.getElementById("passwordInput").required = !0),
            (document.getElementById("confirmPasswordInput").required = !0),
            (resetAlert.innerHTML = `<div class="form__message success" tabindex="-1" autofocus="">
                                    <span class="svg-wrapper"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"/><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"/></svg></span>
                                    OTP verify successfully
                                  </div>`),
            (submitBtn.disabled = !1),
            (submitBtn.textContent = "Submit");
        } else if (confirmPasswordInput != passwordInput)
          resetAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>Password mismatch</li></ul></div>
                  </div>`;
        else {
          const isSuccess = await resetPassword(
            phoneNumber,
            otpInput,
            otpToken,
            passwordInput
          );
          (resetAlert.innerHTML = `<div class="form__message success" tabindex="-1" autofocus="">
                                      <span class="svg-wrapper"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"/><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"/></svg></span>
                                      Reset password successfully
                                    </div>`),
            (window.location.href = "/account/login?reset_success=yes");
        }
      } catch (err) {
        (submitBtn.disabled = !1),
          (submitBtn.textContent = "Submit"),
          (resetAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>${err.message}</li></ul></div>
                  </div>`);
      }
    });
  }
  const registerForm = document.getElementById("middleware-register-form"),
    registerAlert = document.getElementById("register_alert");
  if (((registerAlert.innerHTML = ""), registerForm)) {
    const submitBtn = registerForm.querySelector('button[type="submit"]');
    registerForm.addEventListener("submit", async (e) => {
      console.log(iti.getNumber().replace("+", ""));
      if ((e.preventDefault(), !validatePhone())) return;
      const phoneNumber = iti.getNumber().replace("+", ""),
        nationalId = document.getElementById("CustomerNationalId").value,
        requestType = document.getElementById("RequestType").value,
        otpInput = document.getElementById("otpInput").value,
        otpToken = document.getElementById("otpToken").value,
        name = document.getElementById("customerName").value,
        email = document.getElementById("customerEmail").value,
        password = document.getElementById("customerPassword").value,
        confirmPassword = document.getElementById(
          "customerConfirmPassword"
        ).value,
        referralCode = document.getElementById("referralCode").value;
      try {
        if (otpInput == "") {
          if ((await checkUserExist(phoneNumber, nationalId))?.exists) {
            console.log(phoneNumber);
            (registerAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>It looks like you\u2019ve already registered.</li><li>If you\u2019ve forgotten your password, you can <a href="/account/login#recover">reset it here</a>.</li></ul></div>
                  </div>`),
              (submitBtn.disabled = !1),
              (submitBtn.textContent = "Submit");
            return;
          }
          registerAlert.innerHTML = "";
          const token = await requestOtp(phoneNumber, requestType);
          (document.getElementById(
            "register-message"
          ).innerHTML = `One-Time Password (OTP) is sent to ${phoneNumber.slice(
            0,
            2
          )}xxxxx${phoneNumber.slice(-4)} via SMS`),
            (document.getElementById("phoneWrapper").style.display = "none"),
            (document.getElementById("nationalIdWrapper").style.display =
              "none"),
            (document.getElementById("otpInputWrapper").style.display =
              "block"),
            (document.getElementById(
              "countdown-request-otp-wrapper"
            ).style.display = "block"),
            (document.getElementById("otpInput").required = !0),
            (document.getElementById("otpToken").value = token),
            (submitBtn.disabled = !1),
            (submitBtn.textContent = "Submit"),
            startCountdown(phoneNumber, requestType);
        } else if (password == "") {
          const isSuccess = await verifyOtp(
            phoneNumber,
            requestType,
            otpInput,
            otpToken
          );
          (document.getElementById("register-message").innerHTML =
            "Fill in your details to completion."),
            (document.getElementById("otpInputWrapper").style.display = "none"),
            (document.getElementById("nameWrapper").style.display = "block"),
            (document.getElementById("emailWrapper").style.display = "block"),
            (document.getElementById("passwordWrapper").style.display =
              "block"),
            (document.getElementById("confirmPasswordWrapper").style.display =
              "block"),
            (document.getElementById("referralCodeWrapper").style.display =
              "block"),
            (document.getElementById(
              "countdown-request-otp-wrapper"
            ).style.display = "none"),
            (document.getElementById("customerName").required = !0),
            (document.getElementById("customerEmail").required = !0),
            (document.getElementById("customerPassword").required = !0),
            (document.getElementById("customerConfirmPassword").required = !0),
            (registerAlert.innerHTML = `<div class="form__message success" tabindex="-1" autofocus="">
                                    <span class="svg-wrapper"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"/><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"/></svg></span>
                                    OTP verify successfully
                                  </div>`),
            (submitBtn.disabled = !1),
            (submitBtn.textContent = "Submit");
        } else if (password != confirmPassword)
          registerAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>Password mismatch</li></ul></div>
                  </div>`;
        else {
          const redirectUrl = getCheckoutRedirectUrl();
          redirectUrl
            ? await register(
                nationalId,
                phoneNumber,
                otpInput,
                otpToken,
                name,
                email,
                password,
                referralCode,
                redirectUrl
              )
            : await register(
                nationalId,
                phoneNumber,
                otpInput,
                otpToken,
                name,
                email,
                password,
                referralCode
              ),
            (registerAlert.innerHTML = `<div class="form__message success" tabindex="-1" autofocus="">
                                      <span class="svg-wrapper"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"/><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"/></svg></span>
                                      Registration successfully
                                    </div>`),
            (window.location.href = "/account/login");
        }
      } catch (err) {
        (submitBtn.disabled = !1),
          (submitBtn.textContent = "Submit"),
          (registerAlert.innerHTML = `<div class="form__message error" tabindex="-1" autofocus="">
                    <div>
                      <span class="visually-hidden">Error </span>
                      <span class="svg-wrapper"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg></span>
                      <b>Error</b>
                    </div>
                    <div class="errors"><ul><li>${err.message}</li></ul></div>
                  </div>`);
      }
    });
  }
});
